import { lazy, Suspense, useContext, useEffect } from "react";

/// Components
import Index from "./jsx";
import { connect, useDispatch } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import { getAppSetting } from "./services/AppService";
import { ThemeContext } from "./context/ThemeContext";
import { app } from "./whitelabel";
import { setAppSetting } from "./store/actions/AuthActions";
import ResetPassword from "./jsx/pages/ResetPassword";

const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});

const UNAUTHENTICATED_ROUTES = [
  "/login",
  "/page-forgot-password",
  "/page-register",
  "/reset-password",
];

function App(props) {
  const dispatch = useDispatch();
  const { changePrimaryColor } = useContext(ThemeContext);
  const getAppDetails = async () => {
    setTimeout(() => {
      changePrimaryColor(app.color.primary);
    }, 1000);
    dispatch(setAppSetting(app));
  };
  useEffect(() => {
    getAppDetails();
    if (
      props &&
      props.history &&
      props.history.location &&
      props.history.location.pathname &&
      !UNAUTHENTICATED_ROUTES.includes(props.history.location.pathname)
    ) {
      checkAutoLogin(dispatch, props.history);
    }
  }, [dispatch, props.history]);

  let routes = (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/page-register" component={SignUp} />
      <Route path="/page-forgot-password" component={ForgotPassword} />
      <Route path="/reset-password" component={ResetPassword} />
    </Switch>
  );
  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routes}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
